var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtien({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 46,
    rx: 10,
    fill: "#6D5FF2",
    fillOpacity: 0.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3 16.681C21.638 14.857 24.362 14.857 25.7 16.681L26.468 17.727C28.1269 19.9892 29.1659 22.6456 29.482 25.433C29.6262 26.7093 29.3133 27.9953 28.5989 29.0627C27.8845 30.1301 26.8149 30.9097 25.58 31.263L24.812 31.483C23.6277 31.8211 22.3724 31.8211 21.188 31.483L20.42 31.263C19.1852 30.9097 18.1156 30.1301 17.4012 29.0627C16.6868 27.9953 16.3739 26.7093 16.518 25.433C16.8345 22.6455 17.8738 19.9891 19.533 17.727L20.3 16.681Z",
    stroke: "#6D5FF2",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtien);
export default __webpack_public_path__ + "static/media/Protien.876ac66e0e2f07d6089296f21bfbd86b.svg";
export { ForwardRef as ReactComponent };